import React from "react"

class HomePage extends React.Component {
  render() {
    return <div>Welcome to Navani Diagnostic Centre! Now you can download your reports from here.</div>
  }
}

export default HomePage
